import type { AdoptInput } from "./types.ts"

// The clients default to JSON, which would make axios serialise the form and drop the picture.
export const MULTIPART = { "Content-Type": "multipart/form-data" }

export const adoptForm = ({ kind, method, image, typedText }: AdoptInput) => {
  const form = new FormData()
  form.append("kind", kind)
  form.append("method", method)
  form.append("image", image, `${kind}.png`)
  if (method === "typed" && typedText) form.append("typed_text", typedText)
  return form
}
